<template>
  <a v-if="href && !blank" :href="href" class="btn">
    <slot />
  </a>
  <a v-else-if="href && blank" :href="href" target="_blank" class="btn">
    <slot />
  </a>
  <router-link v-else-if="to" :to="to" class="btn">
    <slot />
  </router-link>
  <button v-else class="btn" v-on="$listeners">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: null,
    },
    to: {
      type: [Object, String],
      default: null,
    },
    blank: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.btn {
  @apply bg-black text-white inline-block text-white py-2 px-6 border border-white;
  transition: all 0.2s;
}

.btn-secondary {
  @apply bg-secondary-500;
}

.btn-sm {
  @apply text-sm py-1;
}
</style>
